import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { Modal } from "antd";
import WaypointEditTabs, {} from "./WaypointEditTabs";
const WaypointEditModal = ({ open, title, tenantId, consignmentId, waypoint, isPickup, readOnly = false, editContactsOnly = false, isCreate = false, saveToServer = false, overwriteAddressOnGeolocate = true, contactNameRequired = false, contactPhoneRequired = false, allowSaveAsSenderReceiver = true, onOk, onCancel }) => {
    const waypointEditTabsRef = useRef(null);
    const onModalOkClicked = () => {
        if (saveToServer) {
            waypointEditTabsRef.current?.validateAndSaveToServer()
                .then(onOk)
                .catch(console.error);
        }
        else {
            waypointEditTabsRef.current?.validateFields()
                .then(onOk)
                .catch(console.error);
        }
    };
    const buildDefaultTitle = () => {
        return isPickup ? "Edit Pickup Address" : "Edit Delivery Address";
    };
    return (_jsxs("div", { onClick: e => e.stopPropagation(), children: [" ", _jsx(Modal, { title: title || buildDefaultTitle(), style: { top: 10 }, width: "900px", open: open, onOk: onModalOkClicked, onCancel: onCancel, destroyOnHidden: true, children: open && waypoint &&
                    _jsx(WaypointEditTabs, { ref: waypointEditTabsRef, tenantId: tenantId, consignmentId: consignmentId, overwriteAddressOnGeolocate: overwriteAddressOnGeolocate, waypoint: waypoint, isPickup: isPickup, isCreate: isCreate, readOnly: readOnly, editContactsOnly: editContactsOnly, contactNameRequired: contactNameRequired, contactPhoneRequired: contactPhoneRequired, allowSaveAsSenderReceiver: allowSaveAsSenderReceiver }) })] }));
};
export default WaypointEditModal;
